"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _d3Shape = require("d3-shape");

var _core = require("@nivo/core");

var _props = require("./props");

var _compute = require("./compute");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const lineGenerator = (0, _d3Shape.line)().x(d => d.x).y(d => d.y);

class PieRadialLabels extends _react.Component {
  render() {
    const _this$props = this.props,
          arcs = _this$props.arcs,
          label = _this$props.label,
          radius = _this$props.radius,
          skipAngle = _this$props.skipAngle,
          linkOffset = _this$props.linkOffset,
          linkDiagonalLength = _this$props.linkDiagonalLength,
          linkHorizontalLength = _this$props.linkHorizontalLength,
          linkStrokeWidth = _this$props.linkStrokeWidth,
          textXOffset = _this$props.textXOffset,
          textColor = _this$props.textColor,
          linkColor = _this$props.linkColor,
          theme = _this$props.theme;
    const labels = (0, _compute.computeRadialLabels)(arcs, {
      getLabel: label,
      radius,
      skipAngle,
      linkOffset,
      linkDiagonalLength,
      linkHorizontalLength,
      textXOffset
    });
    return labels.map(label => _react.default.createElement(_react.Fragment, {
      key: label.arc.data.id
    }, _react.default.createElement("path", {
      d: lineGenerator(label.line),
      fill: "none",
      style: {
        fill: 'none',
        stroke: linkColor(label.arc, theme)
      },
      strokeWidth: linkStrokeWidth
    }), _react.default.createElement("g", {
      transform: "translate(" + label.position.x + ", " + label.position.y + ")"
    }, _react.default.createElement("text", {
      textAnchor: _core.textPropsByEngine.svg.align[label.align],
      dominantBaseline: "central",
      style: _extends({}, theme.labels.text, {
        fill: textColor(label.arc.data, theme)
      })
    }, label.text))));
  }

}

exports.default = PieRadialLabels;

_defineProperty(PieRadialLabels, "defaultProps", {
  skipAngle: 0,
  linkOffset: 0,
  linkDiagonalLength: 16,
  linkHorizontalLength: 24,
  linkStrokeWidth: 1,
  textXOffset: 6
});

PieRadialLabels.propTypes = process.env.NODE_ENV !== "production" ? {
  arcs: _propTypes.default.arrayOf(_props.arcPropType).isRequired,
  label: _propTypes.default.func.isRequired,
  skipAngle: _propTypes.default.number.isRequired,
  radius: _propTypes.default.number.isRequired,
  linkOffset: _propTypes.default.number.isRequired,
  linkDiagonalLength: _propTypes.default.number.isRequired,
  linkHorizontalLength: _propTypes.default.number.isRequired,
  linkStrokeWidth: _propTypes.default.number.isRequired,
  textXOffset: _propTypes.default.number.isRequired,
  textColor: _propTypes.default.func.isRequired,
  linkColor: _propTypes.default.func.isRequired,
  theme: _propTypes.default.shape({
    axis: _core.axisThemePropType.isRequired,
    labels: _core.labelsThemePropType.isRequired
  }).isRequired
} : {};
module.exports = exports.default;